<p>team-dialog works!</p>
